// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --color-primary: #000000;
  --color-white: #ffffff;
  --color-red: #ff0000;
  --color-blue: #00a2ed;
  --color-secondary: rgb(34, 34, 34);
  --font-white: rgb(250, 249, 248);
  --font-light-grey: #a4a4a4;
  --font-medium: 18px !important;
  --medium-screen: 640px !important;
  --small-screen: 960px; }

.screenHeight {
  position: fixed;
  padding: 0;
  margin: 0;
  top: 0;
  left: 0;
  min-width: 100%;
  min-height: 100%; }

.font-color-white {
  color: var(--color-white) !important; }

.font-color-red {
  color: var(--color-red) !important; }

.font-size-medium {
  font-size: var(--font-medium) !important; }

.app-playground {
  height: calc(100%) !important;
  width: 100% !important; }

.height-100 {
  height: 100% !important; }

.blur {
  background: rgba(74, 74, 74, 0.5) !important;
  backdrop-filter: blur(20px) !important;
  -webkit-backdrop-filter: blur(20px) !important; }

.power-button .ms-Button-flexContainer .ms-Icon {
  font-size: 25px !important; }

.blue-screen {
  background-color: var(--color-blue) !important; }
`, "",{"version":3,"sources":["webpack://./src/theme/_variables.scss","webpack://./src/theme/style.scss"],"names":[],"mappings":"AAAA;EACC,wBAAgB;EAChB,sBAAc;EACd,oBAAY;EACZ,qBAAa;EACb,kCAAkB;EAElB,gCAAa;EACb,0BAAkB;EAElB,8BAAc;EAEd,iCAAgB;EAChB,qBAAe,EAAA;;ACXhB;EACC,eAAe;EACf,UAAU;EACV,SAAS;EACT,MAAM;EACN,OAAO;EACP,eAAe;EACf,gBAAgB,EAAA;;AAGjB;EACC,oCAAoC,EAAA;;AAGrC;EACC,kCAAkC,EAAA;;AAGnC;EACC,wCAAwC,EAAA;;AAGzC;EACC,6BAA6B;EAC7B,sBAAsB,EAAA;;AAGvB;EACC,uBAAuB,EAAA;;AAGxB;EACC,4CAA4C;EAC5C,sCAAsC;EACtC,8CAA8C,EAAA;;AAG/C;EAGG,0BAA0B,EAAA;;AAK7B;EACC,8CAA8C,EAAA","sourcesContent":[":root {\n\t--color-primary: #000000;\n\t--color-white: #ffffff;\n\t--color-red: #ff0000;\n\t--color-blue: #00a2ed;\n\t--color-secondary: rgb(34, 34, 34);\n\n\t--font-white: rgb(250, 249, 248);\n\t--font-light-grey: #a4a4a4;\n\n\t--font-medium: 18px !important;\n\n\t--medium-screen: 640px !important;\n\t--small-screen: 960px;\n}\n","@import \"./variables\";\n\n.screenHeight {\n\tposition: fixed;\n\tpadding: 0;\n\tmargin: 0;\n\ttop: 0;\n\tleft: 0;\n\tmin-width: 100%;\n\tmin-height: 100%;\n}\n\n.font-color-white {\n\tcolor: var(--color-white) !important;\n}\n\n.font-color-red {\n\tcolor: var(--color-red) !important;\n}\n\n.font-size-medium {\n\tfont-size: var(--font-medium) !important;\n}\n\n.app-playground {\n\theight: calc(100%) !important;\n\twidth: 100% !important;\n}\n\n.height-100 {\n\theight: 100% !important;\n}\n\n.blur {\n\tbackground: rgba(74, 74, 74, 0.5) !important;\n\tbackdrop-filter: blur(20px) !important;\n\t-webkit-backdrop-filter: blur(20px) !important;\n}\n\n.power-button {\n\t.ms-Button-flexContainer {\n\t\t.ms-Icon {\n\t\t\tfont-size: 25px !important;\n\t\t}\n\t}\n}\n\n.blue-screen {\n\tbackground-color: var(--color-blue) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
